import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// import IconButton from '@material-ui/core/IconButton';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
// import EditIcon from '@material-ui/icons/Edit';

import SafeMuiDatatable from '../generic_components/SafeMuiDatatable';
import * as UTILS from '../utils/utilFunctions';

// prepare column options according to save viewColumn settings
function prepareColumns(columns) {
  const mappedColumns = columns;
  const projectStatusColumnSettings = [];
  columns.forEach(column => {
    if (column.options) {
      if (column.options.display === 'true' || column.options.display === true) {
        projectStatusColumnSettings.push(column.name);
      }
    } else {
      projectStatusColumnSettings.push(column.name);
    }
  });

  return mappedColumns;
}

class CandidateEducations extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { columns: prepareColumns(this.props.columns) };

    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  prepareDataForTable(data) {
    const formatedData = [];
    if (data)
      if (data)
        data.forEach(entry => {
          const educationData = {
            entryId: entry.id,
            fromDate: entry.fromDate,
            tillDate: entry.tillDate,
            description: entry.educationText,
            type: entry.educationType
          };

          formatedData.push([...Object.values(educationData), this.renderEditButton(educationData)]);
        });

    return formatedData;
  }

  getOptions() {
    return {
      filterType: 'checkbox',
      responsive: 'scrollMaxHeight',
      selectableRows: 'none',
      rowsPerPageOptions: [3, 10, 15, 100],
      fixedHeader: false,
      filter: true,
      search: true,
      print: true,
      download: true,
      viewColumns: true,
      downloadOptions: { filename: 'tableDownload.csv', separator: ';' },
      textLabels: {
        body: {
          noMatch: 'Keine passenden Einträge gefunden',
          toolTip: 'sortieren'
        },
        pagination: {
          next: 'Nächste Seite',
          previous: 'Vorherige Seite',
          rowsPerPage: 'Zeilen pro Seite:',
          displayRows: 'von'
        },
        toolbar: {
          search: 'Suche',
          downloadCsv: 'CSV downloaden',
          print: 'Drucken',
          viewColumns: 'Spalten anzeigen',
          filterTable: 'Tabelle filtern'
        },
        filter: {
          all: 'Alle',
          title: 'FILTER',
          reset: 'RESET'
        },
        viewColumns: {
          title: 'Spalten anzeigen',
          titleAria: 'Spalten anzeigen'
        },
        selectedRows: {
          text: 'rows(s) selected',
          delete: 'Delete',
          deleteAria: 'Delete Selected Rows'
        }
      }
    };
  }

  renderEditButton(entry) {
    return (
      <div className="candidateTableAction">
        <IconButton
          className=""
          aria-label="Edit"
          color="primary"
          onClick={() => this.props.handleOpenCandidateEducationUpdatePopUp(entry)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          className=""
          aria-label="Delete"
          color="primary"
          onClick={() => this.props.handleDeleteEntry('educations', entry.entryId)}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    );
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="CandidateEducations row">
          <div className="col-12">
            <SafeMuiDatatable
              title="Ausbildung"
              tableName="candidateEducations"
              data={this.prepareDataForTable(this.props.data.educations)}
              columns={this.state.columns}
              options={this.getOptions()}
            />
          </div>
        </div>
      </div>
    );
  }
}

CandidateEducations.defaultProps = {
  columns: [
    {
      name: 'ID',
      options: {
        display: 'excluded',
        filter: false
      }
    },
    {
      name: 'Von',
      options: {
        customBodyRender: value => UTILS.formatStringToDELocale(value),
        display: true,
        filter: false
      }
    },
    {
      name: 'Bis',
      options: {
        customBodyRender: value => UTILS.formatStringToDELocale(value),
        display: true,
        filter: false
      }
    },
    {
      name: 'Beschreibung',
      options: {
        display: 'true',
        filter: false
      }
    },
    {
      name: 'Typ',
      options: {
        display: 'true',
        filter: false
      }
    },

    {
      name: 'Aktionen',
      options: {
        display: 'true',
        filter: false
      }
    }
  ]
};

CandidateEducations.propTypes = {
  data: PropTypes.object.isRequired,

  columns: PropTypes.array,
  handleOpenCandidateEducationUpdatePopUp: PropTypes.func.isRequired,
  handleDeleteEntry: PropTypes.func.isRequired
};
export default CandidateEducations;
